import { Platform } from 'react-native';
import { Config } from './Config';

const firebaseAppId = Platform.select({
  android: '1:859221759384:android:99d12940642616d2c247ed',
  ios: '1:859221759384:ios:d5035204a07b395dc247ed',
  web: '1:859221759384:web:d9050fbd090c22f5c247ed',
  default: ''
});

export const qaConfig: Config = {
  API_URL: 'https://connect.dev.allydvm.com',
  BASE_URL: 'https://practices.dev.allydvm.com',
  ENVIRONMENT: 'Staging',
  PUSH_URL: 'https://push.dev.allydvm.com',
  FIREBASE: {
    apiKey: 'AIzaSyDVNuDc9tFS4qYMFZAoPVV1WVma0tPQAHo',
    authDomain: 'allydvm-1.firebaseapp.com',
    projectId: 'allydvm-1',
    storageBucket: 'allydvm-1.appspot.com',
    databaseURL: 'https://allydvm-1.firebaseio.com',
    messagingSenderId: '859221759384',
    appId: firebaseAppId
  },
  DEEPLINK_REDIRECT_DOMAINS: [
    'url5711.notifications.dev.allydvm.com',
    'url1325.messages.dev.allydvm.com'
  ]
};
